/* eslint-disable */

import _ from 'lodash';
import history from './history';

export default (checkRenderedDom) => {
  let timeout = null;
  const fixRatio = () => {
    const appElement = document.getElementById('app');
    if ((window.innerWidth / window.innerHeight) < 1.77) {
      if (document.documentElement.style.fontSize !== '1.01vw') {
        document.documentElement.style.fontSize = '1.01vw';
      }
      if (appElement.style.width !== '100%') {
        appElement.style.width = '100%';
      }
      if (appElement.style.height !== `${window.innerWidth * 0.555}px`) {
        appElement.style.height = `${window.innerWidth * 0.555}px`;
      }
    } else {
      if (document.documentElement.style.fontSize !== '1.8vh') {
        document.documentElement.style.fontSize = '1.8vh';
      }
      if (appElement.style.width !== `${appElement.clientHeight * 1.77}px`) {
        appElement.style.width = `${appElement.clientHeight * 1.77}px`;
      }
      if (appElement.style.height !== 'auto') {
        appElement.style.height = 'auto';
      }
    }
    if (timeout) {
      clearTimeout(timeout);
    }
    if (_.get(window, ['location', 'pathname']) !== `/${(_.get(history, ['location', 'pathname'])).split('/')[1]}/search`) {
      timeout = setTimeout(() => checkRenderedDom(), 500);
    }
  };
  setTimeout(fixRatio, 100);
  window.addEventListener('resize', fixRatio);
};
